import { useQuery } from "@tanstack/react-query";
import { handleError } from "api";
import {
  AmountFilterConfigResponse,
  WithdrawApiService,
} from "features/withdraw/api/withdraw-api.service";

export const useGetAmountFilterConfig = () => {
  const { getAmountFilterConfig } = WithdrawApiService();

  return useQuery<AmountFilterConfigResponse>(
    ["withdraw", "amount-filter-config"],
    async () => {
      try {
        return await getAmountFilterConfig();
      } catch (error) {
        handleError(error);
        throw error;
      }
    }
  );
};
